// extracted by mini-css-extract-plugin
module.exports = {"Tabs":"WalletTabs_Tabs__1zuQw","Tab":"WalletTabs_Tab__3O0XC","TabActive":"WalletTabs_TabActive__fVpCh"};